export default "__VITE_ASSET__CNrkyFBs__"